module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-admin-beautiful-wrapper"
  }, [_c('div', {
    staticClass: "vab-main"
  }, [_c('vab-app-main')], 1), _vm._v(" "), _c('footers')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-147615b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/index.vue
// module id = 1081
// module chunks = 1